import React, { useState } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import defaultTexts from '../../../texts/texts'

const MenuItemWrapper = (props) => {
  const { label, value, icon, activeTab, setActiveTab, menuExpanded } = props
  const theme = useTheme()

  const [isHover, setIsHover] = useState(false)

  const buttonWrapperStyle = {
    cursor: 'pointer',
    width: '100%',
    height: '50px',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: '30px',
    padding: '0px 4px',
    borderRadius: '30px',
    transition: 'all 0.2s',
  }

  const iconStyle = {
    width: '44px',
    height: '44px',
    borderRadius: '22px',
    border: '2px solid',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s',
  }

  const titleStyle = {
    width: 'calc(100% - 54px)',
    paddingLeft: '10px',
    fontSize: '14px',
    fontWeight: '500',
  }

  const handleClick = () => {
    setActiveTab(value)
  }

  return (
    <Box
      sx={{
        ...buttonWrapperStyle,
        background: (isHover || value === activeTab) ? theme.palette.violetsAreBlue : theme.palette.vodka,
        color: (isHover || value === activeTab) ? 'white' : theme.palette.violetsAreBlue,
      }}
      onMouseOver={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
      onClick={handleClick}
    >
      <Box
        sx={{
          ...iconStyle,
          borderColor: (isHover || value === activeTab) ? 'white' : theme.palette.violetsAreBlue,
        }}
      >
        {icon}
      </Box>
      {
        menuExpanded &&
        <Box
          sx={{
            ...titleStyle,
            color: (isHover || value === activeTab) ? 'white' : theme.palette.violetsAreBlue,
          }}
        >
          {defaultTexts[label]}
        </Box>
      }      
    </Box>
  )
}

export default MenuItemWrapper